import { FC } from 'react';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useReferralStore } from '@/components/Referral/ReferralProvider';

const Terms: FC = ({}) => {
    const { useLang, useRouter } = useGlobal();
    const { referralInfo } = useReferralStore();
    const { pathname } = useRouter();
    const { t } = useLang('referral');

    return (
        <div className={`${styled.terms}`}>
            <div className="content">
                <h5 className="title">{t('terms.title')}</h5>
                {pathname === '/referral-rewards' || pathname === '/members-festival-referral' ? (
                    <div className="desc" dangerouslySetInnerHTML={{ __html: referralInfo?.receiveTc || '' }}></div>
                ) : (
                    <div className="desc" dangerouslySetInnerHTML={{ __html: referralInfo?.shareTc || '' }}></div>
                )}
            </div>
        </div>
    );
};

export default Terms;
